import Vue from 'vue';
import Vuex from 'vuex';
// 安装Vuex插件 
Vue.use(Vuex);
// 定义store的state 
const state = {
    savehigh: 'home',
    condition:{}
};
// 定义mutations，用于修改state 
const mutations = {
    ['SAVE_SAVE_HEIGH'](state, savehigh) {
        state.savehigh = savehigh;
    },
    ['SAVE_SAVE_CONDITION'](state, condition) {
        state.condition = condition;
    }
};
// 定义actions，用于处理异步操作 
const actions = {
    setSaveHigh({ commit }, savehigh) {
        commit('SAVE_SAVE_HEIGH', savehigh)
    },
    setSaveCondition({ commit }, condition) {
        commit('SAVE_SAVE_CONDITION', condition)
    }
};
// 定义getters，用于获取state中的数据 
const getters = {
    saveHigh(state) {
        return state.savehigh;
    },
    condition(state) {
        return state.condition;
    },
};
// 创建store实例 
const store = new Vuex.Store({ state, mutations, actions, getters });
export default store;